import React, { useEffect } from "react";
import { useStore } from "react-redux";
import { useHistory } from "react-router-dom";
import { useMedia } from "use-media";
import commonUtil from '../../../common/commonUtil';
import { Label } from "../../../components/atoms/label";
import logo from "../../../resources/icons/logo_reservations.svg";
import "../../../resources_membership_hotel/css/common/header.css";
import { Link } from "../../atoms/link";
import User from "../../../User.js";

export const HeaderContainer = (props) => {
  const { onClickOpenReservationPopupWindow, onClickOpenSenyuubiWindow, onClickOpenCrawlWindow, isLoginScreen = false } = props;
  const isWideTablet = useMedia({ maxWidth: "960px" });
  const isWidePhone = useMedia({ maxWidth: "480px" });
  const history = useHistory();
  const store = useStore();
  const crawlMember = store.getState().crawlMember;
  const pointKaiinId = crawlMember ? crawlMember.user_cd : "";

  const onClickBack = () => {
    history.push(props.path, { locationInfo: history.location });
  }
  const onClickIcon = () => {
    if(!isLoginScreen){
      history.push("/reserve/hotel/crawlSearch");
    }
  };
  const onClickSenyuubi = () => {
    const resvKaiinken = store.getState().resvKaiinken;
    if (resvKaiinken?.length) {
      // 会員権
      let keiyakuNo = "";

      resvKaiinken.forEach((data) => {
        if (data.selected === true) {
          keiyakuNo = data.keiyakuNo;
        }
      });
      onClickOpenSenyuubiWindow(keiyakuNo)
    } else {
      onClickOpenCrawlWindow("senyuubi");
    }
  }
  const onClickLogout = () => {
      User.logout();
      store.dispatch({ type:"CRAWL_MEMBER", payload: { crawlMember: {} } });
      history.push("/reserve/hotel/crawlLogin");
  }
  return (
    <header>
      {!props.hideLogo && <div className="membership_headerBaseWrapper">
        <img onClick={onClickIcon} src={logo} className="membership_headerBaseLeftImg" />
        <div className="headerIcons">
          <div className={isLoginScreen ? "hiddenItem" : "crawlSenyuubi_headerButton"} style={styles.bookedConfirm} tabIndex={props.tabIndex}>
            <Link linkTitle="占有日照会" style={styles.linkLabel} onClick={() => onClickSenyuubi()} />
          </div>
          {!isWidePhone && props.bookedConfirmLabel && (
            <div className="membership_headerBaseRight" style={styles.bookedConfirm} tabIndex={props.tabIndex}>
              <Link linkTitle={props.bookedConfirmLabel} style={styles.linkLabel} onClick={() => onClickOpenReservationPopupWindow(pointKaiinId)} />
            </div>
          )}
          {!isLoginScreen && crawlMember?.user_cd && (
            <div className="headerBaseRightLogout">
              <a href="/reserve/hotel/crawlLogin" style={styles.headerLogout} onClick={onClickLogout}>ログアウト</a>
            </div>
          )}
        </div>
        {isWidePhone && props.bookedConfirmLabel && (
          <div className="membership_headerBaseRight" style={styles.bookedConfirm} tabIndex={props.tabIndex}>
            <Link linkTitle={props.bookedConfirmLabel} style={styles.linkLabel} onClick={() => onClickOpenReservationPopupWindow(pointKaiinId)} />
          </div>
        )}
      </div>}
      <div className="membership_headerBaseWrapper2" >
        <div className={isWideTablet ? "membership_headerCenterWrapperSp" : "membership_headerCenterWrapper"}>
          <div className="membership_headerLabelWrapper">
            <div>
              {isWideTablet && props.path ?
                <div style={{ position: "absolute", left: 40, top: "29%", justifyContent: "center" }} onClick={onClickBack}>＜</div>
                : null}
              <Label label={props.categoryLabel1} className={isWideTablet ? "membership_LabelStyleSp1" : "membership_LabelStyle1"} />
              <Label label={props.categoryLabel2} className={isWideTablet ? "membership_LabelStyleSp2" : "membership_LabelStyle2"} />
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

const styles = {


  spLabelStyle1: {
    width: "100%",
    fontSize: "1rem",
    margin: "0 auto",
    marginTop: "20px",
    color: "black",
    textAlign: "center",
    letterSpacing: "0.2rem",
    marginTop: "1rem",
    fontWeight: "700",
  },

  spLabelStyle2: {
    width: "100%",
    fontSize: "0.5rem",
    textAlign: "center",
    marginBottom: "1rem",
    color: "#707070",
  },


  pcLabelStyle1: {
    width: "100%",
    fontSize: "1.5rem",
    margin: "0 auto",
    //marginTop: "20px",
    color: "black",
    textAlign: "center",
    letterSpacing: "0.2rem",
    marginTop: "1.5rem",
    fontWeight: "bold",
  },

  pcLabelStyle2: {
    width: "100%",
    fontSize: "0.8rem",
    textAlign: "center",
    marginBottom: "1.5rem",
    color: "#707070",
  },

  headerBaseRightLogout: {
    float: "right",
    marginTop: "0.7rem",
    marginRight: "0.7rem",
    letterSpacing: "0.05rem",
    fontWeight: 500,
  },

  headerLogout: {
    textDecoration: 'none',
    fontSize: ".7rem",
    textAlign: "center",
    color: "white",
    width: "100%",
  },

  headerIcons: {
    display: 'flex',
    float: 'right',
  },

  bookedConfirm: {
    float: 'none',
  },
};
